import Box from '@mui/material/Box';

/**
 * correlation_id, protocolo, código de ticket.
 *
 * Space Mono e `tabular-nums` porque esses valores são COMPARADOS de bater
 * o olho e copiados para o log — não são lidos como prosa. `user-select:
 * all` para o clique único selecionar o valor inteiro.
 */
export function Identificador({ valor, titulo }: { valor: string; titulo?: string }): React.JSX.Element {
  return (
    <Box
      component="span"
      title={titulo ?? valor}
      sx={(tema) => ({
        fontFamily: tema.anery.familiaDeIdentificador,
        fontVariantNumeric: 'tabular-nums',
        fontSize: '0.75rem',
        color: tema.palette.text.secondary,
        userSelect: 'all',
        wordBreak: 'break-all',
      })}
    >
      {valor}
    </Box>
  );
}
